import template from './qbTransactionModal.html';
import controller from './qbTransactionModal.controller';

let QbTransactionModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'qb-transaction-modal hmodal-info animated zoomIn'
};

export default QbTransactionModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/QbTransactionModal/qbTransactionModal.component.js